module.exports = __webpack_public_path__ + "img/info.e63e0d83.svg";